import React, { useEffect } from "react";
import clsx from "clsx";
import { ToastProps } from "../types/ToastProps";
import { XMarkIcon } from "@heroicons/react/24/outline";

export const Toast: React.FC<ToastProps> = ({
  message,
  type = "info",
  duration = 3000,
  onClose,
}) => {
  useEffect(() => {
    const timeout = setTimeout(onClose, duration);
    return () => clearTimeout(timeout);
  }, [duration, onClose]);

  const bgColors = {
    success: "bg-gray-800",
    error: "bg-red-600",
    info: "bg-blue-600",
    warning: "bg-yellow-600",
  };

  const baseStyles = clsx(
    "fixed top-5 left-1/2 transform -translate-x-1/2 z-50 max-w-sm w-full",
    "animate-slide-up rounded-xl"
  );

  const contentStyles = clsx(
    "text-white px-4 py-3 rounded-xl shadow-md flex justify-between items-center",
    bgColors[type]
  );

  return (
    <>
      <div className={baseStyles}>
        <div className={contentStyles}>
          <span>{message}</span>
          <XMarkIcon
            className="ml-4 text-white hover:text-gray-200 text-xl leading-none h-5 w-5"
            onClick={onClose}
          />
        </div>
      </div>
    </>
  );
};
